<template>
  <div
    id="fee_period"
    v-loading.fullscreen.lock="pageLoading"
  >
    <div class="main">
      <div class="title_bar">
        <div class="left">
          第一次產單請點此<span @click="getExampleExcel()">下載空白範本</span>
        </div>
        <div class="right">
          <span>共計{{ periodData.length }}筆</span>
          <el-button
            class="setting"
            icon="icon-plus"
            round
            @click="handleAdd()"
          >
            新增
          </el-button>
        </div>
      </div>
      <list-frame
        :list-form="periodForm"
        :list-data="periodData"
      >
        <el-table-column
          slot="BillBulkName"
          label="期別"
        >
          <template slot-scope="scope">
            <router-link :to="{name: 'FeePaymentList',params: {id: scope.row.BillBulkId, type: feeType }}">
              {{ scope.row.BillBulkName }}
            </router-link>
          </template>
        </el-table-column>
        <el-table-column
          slot="LastEntryDate"
          label="最後入帳日"
          width="120"
        >
          <template slot-scope="scope">
            <div :class="{'red':isLastEntryInMonth(scope.$index)}">
              {{ scope.row.LastEntryDate }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          slot="Operation"
          label="操作"
          width="250"
        >
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.BillBulkStatus=='未啟用'"
              size="mini"
              type="success"
              plain
              @click="handleSwitchBtn(scope.row,'open')"
            >
              啟用
            </el-button>
            <el-button
              v-if="scope.row.BillBulkStatus=='開啟'"
              size="mini"
              type="danger"
              plain
              @click="handleSwitchBtn(scope.row,'close')"
            >
              關閉
            </el-button>
            <el-button
              v-if="scope.row.BillBulkStatus!='關閉'"
              size="mini"
              plain
              @click="handleEdit(scope.row)"
            >
              編輯
            </el-button>
            <el-button
              v-if="scope.row.BillBulkStatus=='未啟用'"
              size="mini"
              type="danger"
              plain
              @click="handleSwitchBtn(scope.row,'delete')"
            >
              刪除
            </el-button>
            <!-- <el-button
              v-if="scope.row.BillBulkStatus!='未啟用'"
              size="mini"
              @click="handleExportExcel(scope.row)"
              plain>
              下載
            </el-button> -->
          </template>
        </el-table-column>
      </list-frame>
      <TableLoading :is-loading="periodLoading" />
    </div>
    <!-- 新增期別 -->
    <el-dialog
      title="Step1. 確認期別基本資料"
      :visible.sync="addDialog"
      :close-on-click-modal="false"
      :lock-scroll="true"
      center
      :show-close="false"
      @closed="resetForm('feePeriodAdd')"
    >
      <el-form
        ref="feePeriodAdd"
        :model="editData"
        status-icon
        :rules="editRule"
        @submit.native.prevent
      >
        <el-form-item
          class="half"
          label="社區戶名"
          prop="BillCommitteeName"
        >
          <el-input
            v-model="editData.BillCommitteeName"
            size="small"
            maxlength="20"
            placeholder="限20字"
          />
        </el-form-item>
        <el-form-item
          class="half"
          label="社區電話"
          prop="BillCommitteeTel"
        >
          <el-input
            v-model="editData.BillCommitteeTel"
            size="small"
            maxlength="15"
            placeholder="限15字"
          />
        </el-form-item>
        <el-form-item
          label="社區地址"
          prop="BillCommitteeAddress"
        >
          <el-input
            v-model="editData.BillCommitteeAddress"
            size="small"
            maxlength="45"
            placeholder="限45字"
          />
        </el-form-item>
        <el-form-item label="繳費方式">
          <p>
            <el-tag
              v-for="(val) in configData.CommunityPayWay"
              :key="val.Id"
              :type="val.Switch?'success':'info'"
            >
              {{ val.ConfigPayWayShowName }}
            </el-tag>
          </p>
        </el-form-item>
        <el-form-item label="期別備註">
          <el-input
            v-model="editData.BillBulkNote"
            type="textarea"
            maxlength="80"
            :autosize="{ minRows: 3}"
            placeholder="限80字"
            resize="none"
          />
          <span class="num">{{ editData.BillBulkNote.length || 0 }}/80</span>
        </el-form-item>
        <el-form-item
          label="收據開立注意事項"
          class="receiptNotice"
        >
          <p>{{ configData.CommunityBillBulkTemplate.ReceiptNotice || '(無)' }}</p>
        </el-form-item>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          round
          @click="addDialog=false"
        >取消</el-button>
        <el-button
          type="primary"
          round
          @click="handleNextAdd('feePeriodAdd')"
        >下一步</el-button>
      </span>
      <el-dialog
        title="Step.2 新增期別"
        :visible.sync="addDialog2"
        :show-close="false"
        :close-on-click-modal="false"
        :lock-scroll="true"
        append-to-body
        center
        custom-class="feeEditDialog2"
        @closed="resetForm('feePeriodAdd2')"
      >
        <el-form
          ref="feePeriodAdd2"
          :model="editData"
          status-icon
          :rules="editRule"
          @submit.native.prevent
        >
          <el-form-item
            label="期別名稱"
            prop="BillBulkName"
          >
            <el-input
              v-model="editData.BillBulkName"
              size="small"
              maxlength="20"
              placeholder="限20字"
            />
          </el-form-item>
          <el-form-item label="通訊欄">
            <el-input
              v-model="editData.BillBulkCommunicationBar"
              type="textarea"
              maxlength="150"
              :autosize="{ minRows: 3}"
              placeholder="限150字，期別通訊欄＋戶別通訊欄最多顯示12行"
              resize="none"
            />
            <span class="num">{{ editData.BillBulkCommunicationBar.length || 0 }}/150</span>
          </el-form-item>
          <el-form-item label="上傳檔案">
            <el-upload
              class="uploadFileWrap"
              accept="xlsx/*"
              :on-change="handleUploadFile"
              :auto-upload="false"
              :show-file-list="false"
              :disabled="editData.UploadFile?true:false"
              action=""
            >
              <div
                class="uploadedFile"
                :class="{'active':editData.UploadFile}"
              >
                <div
                  v-show="editData.UploadFile"
                  class="fileName"
                >
                  <span>{{ editData.UploadFile?editData.UploadFile.name:'' }}</span>
                  <i
                    class="el-icon-close"
                    aria-hidden="true"
                    @click="editData.UploadFile=''"
                  />
                </div>
                <el-button
                  size="small"
                  :disabled="editData.UploadFile?true:false"
                  icon="icon-upload2"
                  round
                >
                  選擇檔案
                </el-button>
              </div>
            </el-upload>
            <p class="emptyFile">
              第一次產單請點此<span @click="getExampleExcel()">下載空白範本</span>
            </p>
          </el-form-item>
        </el-form>
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button
            round
            @click="addDialog2=false"
          >上一步</el-button>
          <el-button
            type="primary"
            round
            @click="handleSaveAdd('feePeriodAdd2')"
          >儲存</el-button>
        </span>
      </el-dialog>
    </el-dialog>
    <!-- 編輯期別 -->
    <el-dialog
      title="編輯期別"
      :visible.sync="editDialog"
      :close-on-click-modal="false"
      :lock-scroll="true"
      center
      :show-close="false"
      @closed="resetForm('feePeriodEdit')"
    >
      <el-form
        ref="feePeriodEdit"
        :model="editData"
        status-icon
        :rules="editRule"
        @submit.native.prevent
      >
        <el-form-item
          label="期別名稱"
          prop="BillBulkName"
        >
          <el-input
            v-model="editData.BillBulkName"
            size="small"
            maxlength="20"
            placeholder="限20字"
          />
        </el-form-item>
        <el-form-item
          class="half"
          label="社區戶名"
          prop="BillCommitteeName"
        >
          <el-input
            v-model="editData.BillCommitteeName"
            size="small"
            maxlength="20"
            placeholder="限20字"
          />
        </el-form-item>
        <el-form-item
          class="half"
          label="社區電話"
          prop="BillCommitteeTel"
        >
          <el-input
            v-model="editData.BillCommitteeTel"
            size="small"
            maxlength="15"
            placeholder="限15字"
          />
        </el-form-item>
        <el-form-item
          label="社區地址"
          prop="BillCommitteeAddress"
        >
          <el-input
            v-model="editData.BillCommitteeAddress"
            size="small"
            maxlength="45"
            placeholder="限45字"
          />
        </el-form-item>
        <el-form-item label="繳費方式">
          <p>
            <el-tag
              v-for="(val) in editData.SnapshotCommunityPayWays"
              :key="val.Id"
              :type="val.Switch?'success':'info'"
            >
              {{ val.ConfigPayWayShowName }}
            </el-tag>
          </p>
        </el-form-item>
        <el-form-item prop="ConfigHandlingFeeModeId">
          <template slot="label">
            {{ '手續費扣繳' }}
            <a
              class="desc link label_link"
              href="https://www.smartdaily.com.tw/questions/5658674"
              target="_blank"
              rel="noopener"
            >(手續費說明)</a>
          </template>
        </el-form-item>
        <el-form-item label="期別備註">
          <el-input
            v-model="editData.BillBulkNote"
            type="textarea"
            maxlength="80"
            :autosize="{ minRows: 3}"
            placeholder="限80字"
            resize="none"
          />
          <span class="num">{{ editData.BillBulkNote.length || 0 }}/80</span>
        </el-form-item>
        <el-form-item label="期別通訊欄">
          <el-input
            v-model="editData.BillBulkCommunicationBar"
            type="textarea"
            maxlength="150"
            :autosize="{ minRows: 4}"
            placeholder="限150字"
            resize="none"
          />
          <span class="num">{{ editData.BillBulkCommunicationBar.length || 0 }}/150</span>
        </el-form-item>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          round
          @click="editDialog=false"
        >取消</el-button>
        <el-button
          type="primary"
          round
          @click="handleSaveEdit('feePeriodEdit')"
        >儲存</el-button>
      </span>
    </el-dialog>
    <!-- 關閉期別 -->
    <el-dialog
      :title="`確定關閉 ${selectedRowData?'['+selectedRowData.BillBulkName+']':''}`"
      :visible.sync="closeDialog"
      custom-class="sm-size"
      :close-on-click-modal="false"
      :lock-scroll="true"
      center
      :show-close="false"
    >
      <div class="title">
        關閉注意事項
      </div>
      <p>{{ $t('Fee.PeriodCloseNotes') }}</p>
      <p>2. 在「條碼到期日」截止之前，住戶還是可以透過紙本繳費單前往銀行、超商、ATM等通路進行繳費，繳費、對帳的資訊，系統也會正常更新至【繳費列表】。</p>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          round
          @click="closeDialog=false"
        >取消</el-button>
        <el-button
          type="primary"
          round
          @click="handleSwitch(selectedRowData,'Closed')"
        >確認關閉</el-button>
      </span>
    </el-dialog>
    <!-- 刪除期別 -->
    <el-dialog
      title="確定刪除"
      :visible.sync="deleteDialog"
      :close-on-click-modal="false"
      :lock-scroll="true"
      custom-class="sm-size"
      center
      :show-close="false"
    >
      <p>繳費單刪除後將無法復原，確認是否刪除？</p>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          round
          @click="deleteDialog=false"
        >取消</el-button>
        <el-button
          type="danger"
          round
          @click="handleDelete(selectedRowData)"
        >確定</el-button>
      </span>
    </el-dialog>
    <!-- 啟用期別 -->
    <el-dialog
      :title="`確定啟用 ${selectedRowData?selectedRowData.BillBulkName:''} ?`"
      :visible.sync="openDialog"
      :close-on-click-modal="false"
      custom-class="sm-size"
      center
      :show-close="false"
      :lock-scroll="true"
    >
      <div
        v-if="$tempHiddenShow"
        class="title"
      >
        確認繳費資料
      </div>
      <el-table
        v-if="$tempHiddenShow"
        :data="openData.list"
        height="250"
        border
      >
        <el-table-column
          property="household"
          label="戶別"
          width="150"
        />
        <el-table-column
          property="terms"
          label="項目明細"
          width="200"
        />
        <el-table-column
          property="shouldPay"
          label="應繳金額"
        />
        <el-table-column
          property="note"
          label="其他"
        />
      </el-table>
      <div class="title">
        啟用注意事項
      </div>
      <p>1. 繳費單啟用後將於【繳費起日】正式發送繳費通知給住戶開始進行繳費。</p>
      <p>2. 啟用後的繳費單可以關閉，但無法刪除，以確保入帳核銷無誤。</p>
      <p>3. 啟用後住戶即可憑紙本繳費單或直接透過App繳費，繳費單如有異動內容，App會即時更新，紙本繳費單需重新列印提供給住戶。</p>
      <p
        v-if="$tempHiddenShow"
        class="check"
      >
        <el-checkbox v-model="openData.checked">
          我已確認繳費資料無誤，且同意上傳後無法再針對此期資料進行編輯變更及刪除。
        </el-checkbox>
      </p>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          round
          @click="openDialog=false"
        >取消</el-button>
        <el-button
          type="primary"
          :disabled="!openData.checked"
          round
          @click="handleSwitch(selectedRowData,'Open')"
        >我確定並啟用</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import TableLoading from '@/components/TableLoading'
import listFrame from '@/components/ListFrame'
import { uploadExcelFailMessage } from '@/js/utils/fee.js'
export default {
  components: {
    'list-frame': listFrame,
    TableLoading
  },
  props: {
    periodData: Array,
    configData: Object,
    periodDataEnd: Boolean,
    periodLoading: Boolean
  },
  data () {
    const validateSameBulkName = (rule, value, callback) => {
      const nameArray = this.periodData.map(val => val.BillBulkName)
      // eslint-disable-next-line eqeqeq
      if (nameArray.indexOf(value) > -1 && value != this.editDataOri.BillBulkName) {
        callback(new Error(`已有名稱為 ${value} 的期別`))
      } else {
        callback()
      }
    }
    const validatePhone = (rule, value, callback) => {
      const pattern = new RegExp(/^[0-9]{0,15}$/)
      if (value.toString().length === 0) {
        callback()
      } else if (!value.toString().match(pattern)) {
        callback(new Error('請輸入正確格式'))
      } else {
        callback()
      }
    }
    return {
      pageLoading: false, // 頁面loading
      addDialog: false, // 新增期別1
      addDialog2: false, // 新增期別2
      editDialog: false, // 編輯期別
      closeDialog: false, // 關閉期別
      openDialog: false, // 啟用期別
      deleteDialog: false, // 刪除期別
      selectedRowData: null, // 點選列功能 該列資料
      openData: { // 啟用期別資料
        checked: true, // 先不確認期別資料設為true
        list: [
          {
            household: '123',
            terms: [],
            shouldPay: '',
            note: ''
          },
          {
            household: '456',
            terms: [],
            shouldPay: '',
            note: ''
          },
          {
            household: '456',
            terms: [],
            shouldPay: '',
            note: ''
          }
        ]

      },
      editData: { // 新增編輯期別資料
        BillBulkName: '',
        BillBulkNote: '',
        BillCommitteeName: '',
        BillCommitteeAddress: '',
        BillCommitteeTel: '',
        BillBulkCommunicationBar: '',
        UploadFile: null
      },
      editDataOri: {}, // 新增編輯資料原始資料
      editRule: { // 表單驗證規則
        BillBulkName: [
          { required: true, message: '請輸入期別名稱', trigger: 'change' },
          { validator: validateSameBulkName, trigger: 'change' }
        ],
        BillCommitteeName: [
          { required: true, message: '請輸入社區戶名', trigger: 'change' }
        ],
        BillCommitteeAddress: [
          { required: true, message: '請輸入社區地址', trigger: 'change' }
        ],
        BillCommitteeTel: [
          { required: true, message: '請輸入社區電話', trigger: 'change' },
          { validator: validatePhone, trigger: 'change' }
        ]
      },
      // 列表格式
      periodForm: [
        {
          label: '編號',
          width: '60',
          sortable: true,
          type: 'index',
          customIndex: this.indexMethod
        },
        {
          slot: 'BillBulkName'
        },
        {
          prop: 'BillBulkCreateDate',
          label: '建立日期',
          width: '120'
        },
        {
          prop: 'PayRate',
          label: '繳費情形',
          width: '120',
          sortable: true,
          align: 'right'
        },
        {
          prop: 'BillsShouldAmountString',
          label: this.$t('Fee.BillShouldReceiptAmount'),
          width: '150',
          align: 'right'
        },
        {
          prop: 'BillsActualAmountString',
          label: this.$t('Fee.BillActualReceiptAmount'),
          width: '150',
          align: 'right'
        },
        {
          slot: 'LastEntryDate'
        },
        {
          prop: 'StatusText',
          label: '狀態',
          width: '75',
          align: 'center',
          sortable: true,
          component: 'colored'
        },
        {
          slot: 'Operation'
        }
      ],
      feeType: 'management'
    }
  },
  watch: {
    addDialog (status) {
      // eslint-disable-next-line eqeqeq
      if (status == false) {
        this.addDialog2 = false
      }
    }
  },
  mounted () {
    window.addEventListener('scroll', this.autoShow, true)
    window.addEventListener('touchmove', this.autoShow, true)
    this.feeType = this.$route.params.type
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.autoShow, true)
    window.removeEventListener('touchmove', this.autoShow, true)
  },
  methods: {
    autoShow () {
      // 視窗滾動條高度
      const ScrollTop = document.documentElement.scrollTop
      // console.log(`視窗滾動條高度:${ScrollTop}`)
      // 視窗可視範圍高度
      const ClientHeight = document.documentElement.clientHeight
      // console.log(`視窗可視範圍高度:${ClientHeight}`)
      // 內容實際高度
      const ScrollHeight = document.documentElement.scrollHeight
      // console.log(`內容實際高度:${ScrollHeight}`)
      // console.log(ScrollTop+ClientHeight +" : "+ ScrollHeight)
      // console.log(`${ScrollTop+ClientHeight}:${ScrollHeight}`)
      // eslint-disable-next-line eqeqeq
      if ((ScrollTop + ClientHeight >= ScrollHeight - 200) && !this.periodLoading && this.$router.currentRoute.name == 'FeePeriodList') {
        console.log(this.periodDataEnd)
        if (!this.periodDataEnd) {
          this.$emit('getMorePeriod', true)
        }
      }
    },
    getExampleExcel () { // 取得excel空白範本
      this.pageLoading = true
      const config = {
        responseType: 'blob' // important
      }
      apiBillservice.BillBulk.GetImportExcelTemplate(
        config
      ).then((res) => {
        console.log(res)
        const url = window.URL.createObjectURL(new Blob([res.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `${decodeURIComponent(res.headers['content-disposition'].split(';')[1].split('=')[1].replace(/"/g, ''))}`) // or any other extension
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
        this.pageLoading = false
      }).catch((err) => {
        console.log(err)
        console.log(err.response)
        this.pageLoading = false
        this.$message({
          message: '取得空白範本失敗，請稍後再試',
          type: 'warning'
        })
      })
    },
    indexMethod (index) { // 列表index反序
      // return this.periodData.length - index;
      return index + 1
    },
    handleAdd () { // 新增期別step1
      this.editData = Object.assign({}, {
        BillBulkName: '',
        BillBulkNote: this.configData.CommunityBillBulkTemplate.BillBulkNote,
        BillCommitteeName: this.configData.CommunityBillBulkTemplate.CommitteeInfoName,
        BillCommitteeAddress: this.configData.CommunityBillBulkTemplate.CommitteeInfoAddress,
        BillCommitteeTel: this.configData.CommunityBillBulkTemplate.CommitteeInfoTel,
        BillBulkCommunicationBar: this.configData.CommunityBillBulkTemplate.BillBulkCommunicationBar,
        PayDate: [],
        BarcodeDue: '',
        UploadFile: ''
      })
      this.editDataOri = _cloneDeep(this.editData)
      this.addDialog = true
    },
    handleNextAdd (formName) { // 新增期別step2
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addDialog2 = true
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleUploadFile (e) { // 新增期別 - 選擇檔案
      console.log(e)
      this.editData.UploadFile = e
    },
    handleSaveAdd (formName) { // 新增期別 - 儲存
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.editData.UploadFile) { // 有上傳檔案
            // eslint-disable-next-line eqeqeq
            if (this.editData.UploadFile.name.indexOf('.xlsx') == -1 || this.editData.UploadFile.name.indexOf('.xlsx') + 5 != this.editData.UploadFile.name.length) { // 檔案附檔名為.xlsx 且.xlsx在最後面
              this.$message({
                message: '檔案格式有誤，請選擇檔案上傳',
                type: 'warning'
              })
              return false
            }
            this.pageLoading = true
            const requestData = new FormData()
            requestData.append('Name', this.editData.BillBulkName)
            requestData.append('CommunicationBar', this.editData.BillBulkCommunicationBar)
            requestData.append('Note', this.editData.BillBulkNote)
            requestData.append('BillCommitteeInfo.Name', this.editData.BillCommitteeName)
            requestData.append('BillCommitteeInfo.Tel', this.editData.BillCommitteeTel)
            requestData.append('BillCommitteeInfo.Address', this.editData.BillCommitteeAddress)
            requestData.append('File', this.editData.UploadFile.raw)
            apiBillservice.BillBulk.PostImportExcelTemplate(
              requestData
            ).then((res) => {
              console.log(res)
              if (res?.data?.Data?.BillBulkId !== null) {
                this.$emit('updatePeriod')
                this.addDialog = false
                this.$message({
                  message: '新增期別成功',
                  type: 'success'
                })
              } else if (res?.data?.Data?.ExcelUploadErrors && res?.data?.Data?.ExcelUploadErrors.length > 0) {
                const { errorText, showDownloadBtn } = uploadExcelFailMessage(res.data.Data.ExcelUploadErrors)
                if (showDownloadBtn) {
                  this.$confirm(errorText, this.$t('Fee.UploadExcelFail'), {
                    confirmButtonText: this.$t('General.Confirm'),
                    cancelButtonText: this.$t('Fee.DownloadTemplate'),
                    showClose: false,
                    dangerouslyUseHTMLString: true,
                    distinguishCancelAndClose: true,
                    customClass: 'excel-fail-confirm'
                  }).then((res) => {
                    console.log('then', res)
                  }).catch((res) => {
                    if (res === 'cancel') this.getExampleExcel()
                    console.log('catch', res)
                  })
                } else {
                  this.$confirm(errorText, this.$t('Fee.UploadExcelFail'), {
                    confirmButtonText: this.$t('General.Confirm'),
                    showClose: false,
                    dangerouslyUseHTMLString: true,
                    distinguishCancelAndClose: true,
                    customClass: 'excel-fail-confirm'
                  }).then((res) => {
                    console.log('then', res)
                  }).catch((res) => {
                    console.log('catch', res)
                  })
                }
              } else {
                this.$message({
                  message: this.$t('Fee.StoreExcelFail'),
                  type: 'error'
                })
              }
              this.pageLoading = false
            }).catch(err => {
              console.log(err.response)
              // eslint-disable-next-line eqeqeq
              if (err.response && err.response.status && err.response.status == 400) {
                this.$message({
                  message: err.response.data.ErrorMessage.Description,
                  type: 'warning'
                })
              } else {
                this.$message({
                  message: '新增期別失敗，請稍後再試',
                  type: 'warning'
                })
              }
              this.pageLoading = false
            })
          } else { // 無上傳檔案
            this.pageLoading = true
            const requestData = {
              Name: this.editData.BillBulkName,
              CommunicationBar: this.editData.BillBulkCommunicationBar,
              Note: this.editData.BillBulkNote,
              BillCommitteeInfo: {
                Name: this.editData.BillCommitteeName,
                Tel: this.editData.BillCommitteeTel,
                Address: this.editData.BillCommitteeAddress
              }
            }
            apiBillservice.BillBulk.PostBillBulk(
              requestData
            ).then((res) => {
              console.log(res)
              this.$emit('updatePeriod')
              this.addDialog = false
              this.$message({
                message: '新增期別成功',
                type: 'success'
              })
              this.pageLoading = false
            }).catch(err => {
              console.log(err.response)
              this.$message({
                message: '新增期別失敗，請稍後再試',
                type: 'warning'
              })
              this.pageLoading = false
            })
          }
        } else {
          this.$message({
            showClose: true,
            message: '新增期別失敗 - 請確認各欄位均已填妥',
            type: 'warning'
          })
          return false
        }
      })
    },
    handleEdit (row) { // 編輯期別
      this.editData = _cloneDeep(row)
      this.editDataOri = _cloneDeep(this.editData)
      this.editDialog = true
    },
    handleSaveEdit (formName) { // 編輯期別 - 儲存
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!_isEqual(this.editData, this.editDataOri)) { // 資料更動
            this.pageLoading = true
            const queryPath = {
              billBulkId: this.editData.BillBulkId
            }
            const requestData = {
              BillBulkName: this.editData.BillBulkName,
              BillBulkNote: this.editData.BillBulkNote,
              BillCommitteeName: this.editData.BillCommitteeName,
              BillCommitteeAddress: this.editData.BillCommitteeAddress,
              BillCommitteeTel: this.editData.BillCommitteeTel,
              BillBulkCommunicationBar: this.editData.BillBulkCommunicationBar
            }
            apiBillservice.BillBulk.PutBillBulk(
              queryPath,
              requestData
            ).then((res) => {
              console.log(res)
              this.$emit('updatePeriod')
              this.editDialog = false
              this.pageLoading = false
              this.$message({
                message: '編輯期別成功',
                type: 'success'
              })
            }).catch(err => {
              this.pageLoading = false
              this.$message({
                message: '編輯期別失敗，請稍後再試',
                type: 'warning'
              })
              console.log(err.response)
            })
          } else {
            console.log(this.editData)
            this.editDialog = false
          }
        } else {
          this.$message({
            showClose: true,
            message: '編輯期別失敗 - 請確認各欄位均已填妥',
            type: 'warning'
          })
          return false
        }
      })
    },
    handleSwitchBtn (item, action) { // 點擊期別啟用關閉按鈕
      this.selectedRowData = item
      switch (action) {
        case 'close':
          this.closeDialog = true
          break
        case 'delete':
          this.deleteDialog = true
          break
        case 'open':
          this.openDialog = true
          break
        default:
          console.log('123')
      }
    },
    handleSwitch (item, action) { // 期別啟用 期別關閉
      this.pageLoading = true
      const queryPath = {
        billBulkId: item.BillBulkId,
        billStatusEnum: action
      }
      apiBillservice.BillBulk.PutBillBulkStatus(
        queryPath
      ).then((res) => {
        // eslint-disable-next-line eqeqeq
        if (action == 'Open') {
          // item.BillBulkStatus = '開啟'
          this.openDialog = false
          this.pageLoading = false
        // eslint-disable-next-line eqeqeq
        } else if (action == 'Closed') {
          // item.BillBulkStatus = '關閉'
          this.closeDialog = false
          this.pageLoading = false
        }
        this.$emit('updatePeriod')
      }).catch((err) => {
        this.pageLoading = false
        // eslint-disable-next-line eqeqeq
        const errorMsg = action == 'Open' ? '期別啟用失敗，請檢查期別內是否有未過期繳費單，如無問題請再試一次' : '期別狀態改變失敗，請稍後再試'
        this.$message({
          message: errorMsg,
          type: 'warning'
        })
        console.log(err.response)
      })
    },
    handleDelete (item) { // 期別刪除
      this.pageLoading = true
      const queryPath = {
        billBulkId: item.BillBulkId
      }
      apiBillservice.BillBulk.DeleteBillBulk(
        queryPath
      ).then((res) => {
        console.log(res)
        this.$emit('updatePeriod')
        this.deleteDialog = false
        this.pageLoading = false
        this.$message({
          message: '刪除期別成功',
          type: 'success'
        })
      }).catch((err) => {
        this.pageLoading = false
        this.$message({
          message: '刪除期別失敗，請稍後再試',
          type: 'warning'
        })
        console.log(err.response)
      })
    },
    isLastEntryInMonth (ind) { // 最後入帳日是否在30日內
      if (this.periodData && this.periodData[ind].LastEntryDate) {
        const now = new Date().getTime()
        const lastEntry = new Date(this.periodData[ind].LastEntryDate).getTime()
        const thirtyDays = 30 * 24 * 60 * 60 * 1000
        if (now - lastEntry <= thirtyDays) {
          return true
        } else {
          return false
        }
      }
    },
    resetForm (formName) { // 重置表格資料
      this.$refs[formName].resetFields()
    }
  }
}
</script>
<style lang="sass">
.excel-fail-confirm
  .el-message-box__btns
    display: flex
    justify-content: space-between
    & button:nth-child(1)
      border: unset
      padding: 0
      color: $mainColor
      text-underline-offset: 7px
      font-weight: unset
      font-size: 14px
      &:hover
        background-color: transparent
.feeEditDialog2
  +basicDialog
  .el-dialog__body
    min-height: 500px
  .uploadFileWrap
    display: inline-block
    width: 100%
    margin: 5px 0
    .uploadedFile
      &.active
        border-radius: 5px
        padding: 0 0 0 10px
        line-height: 1
        .fileName
          display: inline-block
          span
            vertical-align: middle
            word-break: break-all
          i
            color: $dangerColor
            vertical-align: middle
            padding: 0 5px
  .emptyFile
    color: $subFontColor
    span
      color: $mainColor
      cursor: pointer
</style>
<style lang="sass" scoped>

#fee_period
  ::v-deep .el-dialog
    +basicDialog
    .title
      font-size: map-get($fontSize,large)
      font-weight: bold
      margin-bottom: 20px
      color: $mainFontColor
    p
      line-height: 25px
      color: $subFontColor
      &.check
        text-align: center
        line-height: 40px
        .el-checkbox__label
          color: $dangerColor
    .receiptNotice
      .el-form-item__label
        font-size: map-get($fontSize,large)
        font-weight: bold
        color: $mainFontColor
      p
        white-space: pre-line
  .main
    min-width: 700px
    color: $mainFontColor
    .title_bar
      display: flex
      justify-content: space-between
      align-items: center
      margin: 15px 0
      .left
        background-color: $bgDark3
        color: $subFontColor
        padding: 9px 16px 7px
        span
          color: $mainColor
          cursor: pointer
      .right
        span
          margin: 0 20px
          color: $mainFontColor
          vertical-align: middle
    .el-table
      .red
        color: $dangerColor
</style>
